import { render, staticRenderFns } from "./ExpertAuditCommentModal.vue?vue&type=template&id=dd18f71c&scoped=true"
import script from "./ExpertAuditCommentModal.vue?vue&type=script&lang=js"
export * from "./ExpertAuditCommentModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd18f71c",
  null
  
)

export default component.exports